import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import tag from '../../../constants/tag-constants';

function HorizontalCardPanel({ classes, icon, history }) {

  const { t: trans } = useTranslation();
  const [featured, setFeatured] = useState([]);
  const products = useSelector(state => state.products);

  useEffect(() => {
    // Filtering out the featured products via the featured tag
    if (products && Array.isArray(products.data)) {
      const featuredProducts = products.data.filter(
        p => p.productTags && p.productTags.some(pt => pt.tag.name === tag.featured)
      )   
      setFeatured(featuredProducts);
    }
  }, [products.data]);

  const handleNavigation = (id) => {
    history.push(`/integration/${id}`);
  }

  return (
    <div className={`card-panel ${classes ? classes : ''}`}>
      <h3>{trans('featured.popular-integrations')}</h3>
      <Row className="cards-container">
        {featured.length ? featured.map((product, index) => {
          return <Col lg={3} key={index}>
            <section className="feature-card" onClick={() => handleNavigation(product.id)}>
              <figure>
                <img src={product.iconReference ? product.iconReference : icon} alt='featuredlogo' />
              </figure>
              <span>{product.label}</span>
            </section>
          </Col>
        }) : null}
      </Row>
    </div >
  );
}

export default withRouter(HorizontalCardPanel);
